<div class="dynamic-chart-wrapper" *ngIf="customOptions" dir="ltr">
  <formio-loader></formio-loader>
  <ng-container *ngIf="customOptions.echartsOption;else chartJs">
    <div class="chart-container {{customOptions.class}}">
      <div id="eChart-{{formioComponent.component.key}}" style="width: 100%;height: 400px;{{customOptions.style}}"></div>
    </div>
  </ng-container>

  <ng-template #chartJs>
    <div class="chart-container {{customOptions.class}}" style="visibility: {{isReady ? 'visible' : 'hidden'}};">
      <canvas id="chartJs-{{formioComponent.component.key}}" style="{{customOptions.style}}"></canvas>
    </div>
  </ng-template>

</div>